var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, GridItem } from "@chakra-ui/react";
import { SearchResultsJobDetailsHeaderContent } from "@/components/SearchResults/SearchResultsJobDetailsHeaderContent";
import { useDetectMobileViewPort } from "@/components/cortex/hooks/useDetectMobileViewPort";
import { ApplyButtonWrapper } from "./ApplyButtonWrapper";
import { SearchResultsCompanyLogo } from "./SearchResultsCompanyLogo";
export var SearchResultsJobDetailsHeader = function (_a) {
    var job = _a.job;
    var isMobile = useDetectMobileViewPort().isMobile;
    if (isMobile) {
        return (_jsxs(Grid, __assign({ templateColumns: "repeat(13, 1fr)" }, { children: [_jsx(GridItem, __assign({ colSpan: 8 }, { children: _jsx(SearchResultsJobDetailsHeaderContent, { job: job }) })), _jsxs(GridItem, __assign({ colSpan: 5 }, { children: [_jsx(SearchResultsCompanyLogo, { job: job, variant: "details" }), _jsx(ApplyButtonWrapper, { job: job, variant: "searchResultsDetailsHeader" })] }))] })));
    }
    return (_jsxs(Grid, __assign({ templateColumns: "repeat(9, 1fr)" }, { children: [_jsx(GridItem, __assign({ colSpan: 1 }, { children: _jsx(SearchResultsCompanyLogo, { job: job, variant: "details" }) })), _jsx(GridItem, __assign({ colSpan: 4 }, { children: _jsx(SearchResultsJobDetailsHeaderContent, { job: job }) })), _jsx(GridItem, __assign({ colSpan: 3 }, { children: _jsx(ApplyButtonWrapper, { job: job, variant: "searchResultsDetailsHeader" }) }))] })));
};
